var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBox(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "box-3-line"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10 3.125L15.9375 6.5625V13.4375L10 16.875L4.0625 13.4375V6.5625L10 3.125ZM5.93367 6.92356L10.0001 9.27775L14.0664 6.92359L10 4.56938L5.93367 6.92356ZM5.3125 8.00831V12.7168L9.37506 15.0688V10.3603L5.3125 8.00831ZM10.6251 15.0688L14.6875 12.7168V8.00836L10.6251 10.3603V15.0688Z",
    fill: "#111111"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBox);
export default __webpack_public_path__ + "static/media/box.309cf206a9890b25ef23d4e8e1b3f438.svg";
export { ForwardRef as ReactComponent };